module.exports = __webpack_public_path__ + "img/img94_2.dd4f3f81.png";